import React from 'react';
import { Archive, AlertCircle } from 'lucide-react';
import BaseModal from './BaseModal';

/**
 * Modal de confirmación para archivar una propiedad
 */
const ArchivePropertyModal = ({ property, onConfirm, onCancel }) => {
  return (
    <BaseModal
      onClose={onCancel}
      title="Archivar Propiedad"
      subtitle="Esta acción es reversible"
      icon={<Archive className="w-6 h-6 text-amber-400" />}
      iconBg="bg-amber-500/10"
      footer={
        <>
          <button
            onClick={onCancel}
            className="flex-1 bg-slate-700 text-white font-medium py-3 rounded-lg hover:bg-slate-600 transition-all"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 font-semibold py-3 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all"
          >
            Archivar
          </button>
        </>
      }
    >
      <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4">
        <p className="text-amber-400 font-medium mb-2">
          ¿Archivar "{property.title}"?
        </p>
      </div>

      <div className="space-y-3 text-sm text-slate-300">
        <div className="flex items-start gap-2">
          <AlertCircle className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
          <p>Los invitados ya no podrán acceder a esta propiedad</p>
        </div>
        <div className="flex items-start gap-2">
          <AlertCircle className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
          <p>Se conservará todo el historial (ofertas, invitados, engagement)</p>
        </div>
        <div className="flex items-start gap-2">
          <AlertCircle className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
          <p>Podrás reactivarla en cualquier momento desde el panel de archivadas</p>
        </div>
      </div>
    </BaseModal>
  );
};

export default ArchivePropertyModal;
